import styled from 'styled-components'
import { grid } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex).attrs({
  pt: [32, 32, 96],
})`
  width: 100%;
  justify-content: center;
  position: relative;
  color: ${themeGet('colors.white')};
`

export const Content = styled.div
  .attrs({
    gridGap: [16, 16, 36],
    gridTemplateColumns: `repeat(auto-fill, minmax(144px, 1fr))`,
  })
  .withConfig({ shouldForwardProp })`
  display: grid;
  width: 100%;

  ${grid}
`
